import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"

import Column from "../../common/components/Column"
import { GlassMixinVariant2 } from "../../common/components/GlassMixin"
import Row from "../../common/components/Row"
import { trimLongString } from "../../common/utils"

/**
 * Top-right account name and email on the standalone MLS pages, styled like
 * the app header (NavbarRightSection), so staff and the customer can confirm
 * whose OneBase account this is. No name: the email alone, like the app.
 * Above dialog backdrops so it stays readable.
 */
export default function AccountHeaderBar({ accountName, accountEmail }) {
  if (!accountName && !accountEmail) return null
  return (
    <HeaderBar>
      <Column sx={{ alignItems: "flex-end", minWidth: 0 }}>
        <Typography
          variant="h4"
          component="span"
          color="text.pink"
          title={accountName || accountEmail}
          sx={{ whiteSpace: "nowrap" }}
        >
          {trimLongString(accountName || accountEmail, accountName ? 20 : 40)}
        </Typography>
        {accountName && accountEmail ? (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ whiteSpace: "nowrap" }}
          >
            {accountEmail}
          </Typography>
        ) : null}
      </Column>
    </HeaderBar>
  )
}

const HeaderBar = styled(Row)(({ theme }) => ({
  position: "fixed",
  top: theme.spacing(1),
  left: theme.spacing(1),
  right: theme.spacing(1),
  zIndex: theme.zIndex.modal + 1,
  justifyContent: "flex-end",
  alignItems: "center",
  paddingInline: theme.spacing(2),
  paddingBlock: theme.spacing(1),
  borderRadius: "16px",
  ...GlassMixinVariant2,
}))

/** Space the page content leaves for the bar. */
export const ACCOUNT_HEADER_OFFSET = 9
